import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-translate-push-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [isTranslator]="true"
      [templateType]="templateType"
      templateBasePath="/translate-push-template/"
      channelLabel="Push"
      namePlaceholder="Enter push name"
      emptyMessage="No push found!"
      heartbeatType="push"
      [showResponsysButton]="true" />
  `
})
export class TranslatePushTemplateComponent {
  protected readonly templateType = TypeEnum.PUSH;
}
